/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import AudioPlayer from '../audio-player/audio-player'


const AudioSection = () => {
    const [audioSourceURL, setAudioSourceURL] = useState('https://www.learningcontainer.com/wp-content/uploads/2020/02/Kalimba.mp3')

    const handleAudioSrcURL = (e) => {
        setAudioSourceURL(e.target.value)
    }
    return (
        <>
            <div>
                <input
                    type="text"
                    id="audioSrc"
                    value={audioSourceURL}
                    onChange={handleAudioSrcURL}
                    style={{ height: '20px', fontSize: '12px', width: '800px', padding: '10px', margin: '10px' }}
                    placeholder="Please input audio (mp3) source url " />
            </div>
            <div style={{ fontSize: '14px' }} >
                Please enter audio source (url) in the above textbox to test
                <ul>
                    <li>
                        https://www.learningcontainer.com/wp-content/uploads/2020/02/Kalimba.mp3
                    </li>
                    <li>
                        https://cdn.pixabay.com/audio/2024/01/20/audio_bb461c7ea3.mp3
                    </li>
                    <li>
                        https://cdn.pixabay.com/audio/2025/01/05/audio_f4b500c3cb.mp3
                    </li>
                </ul>
            </div>
            <div className="samples">
                <div className="buttons-container">
                    <div className="button-wrapper">
                        <AudioPlayer audioSourceURL={audioSourceURL} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default AudioSection
